(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["volt-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.voltMenuBoot) { window.voltMenuBoot(); return; }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const controller = new AbortController();
    const on = (target, name, callback) => target.addEventListener(name, callback, {signal: controller.signal});
    const desktop = matchMedia('(min-width: 1024px)');
    const items = [...root.querySelectorAll('[data-vmm-item]')];
    const shell = root.querySelector('.vmm-shell');
    const header = root.closest('.header-section');
    const triggers = [...header.querySelectorAll('[data-vmm-open-drawer]')];
    let active = null, opener = null, openTimer, closeTimer, previousOverflow;
    let inertElements = [];
    const visibleFocusable = scope => [...scope.querySelectorAll('a[href],button:not([disabled]),select,input:not([type="hidden"]),[tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[inert]'));
    const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
    function closePanel(restoreFocus = false) {
      clearTimers();
      const previous = active;
      active = null;
      items.forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('[data-vmm-toggle]')?.setAttribute('aria-expanded', 'false');
        item.querySelector('[data-vmm-panel]')?.setAttribute('inert', '');
      });
      root.classList.remove('is-open');
      if (restoreFocus) previous?.querySelector('[data-vmm-toggle]')?.focus();
    }
    function openPanel(item, focus = false) {
      clearTimers();
      closePanel();
      active = item;
      item.classList.add('is-open');
      item.querySelector('[data-vmm-toggle]').setAttribute('aria-expanded', 'true');
      const panel = item.querySelector('[data-vmm-panel]');
      panel.removeAttribute('inert');
      root.classList.add('is-open');
      root.dispatchEvent(new CustomEvent('vmm:open', { detail: { panel } }));
      if (focus || !desktop.matches) visibleFocusable(panel)[0]?.focus();
    }
    function setDrawer(open, restoreFocus = true) {
      closePanel();
      if (open === root.classList.contains('is-drawer')) return;
      root.classList.toggle('is-drawer', open);
      triggers.forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (open) {
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        shell.inert = false;
        shell.setAttribute('role', 'dialog');
        shell.setAttribute('aria-modal', 'true');
        let ancestor = shell;
        while (ancestor.parentElement && ancestor !== document.body) {
          [...ancestor.parentElement.children].filter(el => el !== ancestor && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).forEach(el => {
            inertElements.push([el, el.inert]); el.inert = true;
          });
          ancestor = ancestor.parentElement;
        }
        root.querySelector('[data-vmm-close-drawer]').focus();
      } else {
        document.documentElement.style.overflow = previousOverflow ?? '';
        inertElements.forEach(([el, value]) => { el.inert = value; });
        inertElements = [];
        shell.removeAttribute('role');
        shell.removeAttribute('aria-modal');
        shell.inert = !desktop.matches;
        if (restoreFocus) opener?.focus();
      }
    }
    items.forEach(item => {
      const button = item.querySelector('[data-vmm-toggle]');
      on(item, 'mouseenter', () => {
        if (!desktop.matches || !matchMedia('(hover:hover)').matches) return;
        clearTimers();
        if (!button) { closePanel(); return; }
        openTimer = setTimeout(() => openPanel(item), active ? 0 : 110);
      });
      if (!button) return;
      on(button, 'click', () => active === item ? closePanel() : openPanel(item));
      [button, item.querySelector('.vmm-link')].forEach(control => on(control, 'keydown', event => {
        if (desktop.matches && event.key === 'ArrowDown') {
          event.preventDefault(); openPanel(item, true);
        }
      }));
    });
    on(root, 'mouseleave', () => {
      if (!desktop.matches) return;
      clearTimeout(openTimer); closeTimer = setTimeout(() => closePanel(), 220);
    });
    on(root, 'mouseenter', () => clearTimeout(closeTimer));
    on(root, 'change', event => {
      if (event.target.matches('.vmm-localization select')) event.target.form.requestSubmit();
    });
    on(root, 'click', event => {
      if (event.target.closest('[data-vmm-back]')) closePanel(true);
      if (event.target.closest('[data-vmm-close-drawer]')) setDrawer(false);
      if (event.target.closest('[data-vmm-scrim]')) closePanel();
      const accordion = event.target.closest('[data-vmm-acc]');
      if (accordion && !desktop.matches) {
        const group = accordion.closest('.vmm-group');
        const open = group.dataset.open !== 'true';
        group.dataset.open = String(open);
        accordion.setAttribute('aria-expanded', String(open));
      }
    });
    triggers.forEach(button => on(button, 'click', () => {
      if (desktop.matches) return;
      opener = button; setDrawer(!root.classList.contains('is-drawer'));
    }));
    on(document, 'keydown', event => {
      if (event.key === 'Escape') {
        if (active) { event.preventDefault(); closePanel(true); }
        else if (root.classList.contains('is-drawer')) { event.preventDefault(); setDrawer(false); }
      }
      if (event.key === 'Tab' && root.classList.contains('is-drawer')) {
        const scope = active ? active.querySelector('[data-vmm-panel]') : shell;
        const elements = visibleFocusable(scope), first = elements[0], last = elements.at(-1);
        if (event.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
      }
    });
    on(root, 'keydown', event => {
      if (!desktop.matches || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      const buttons = items.map(item => item.querySelector('.vmm-link'));
      const index = items.indexOf(document.activeElement.closest('[data-vmm-item]'));
      if (!document.activeElement.matches('.vmm-link, [data-vmm-toggle]')) return;
      if (index < 0) return;
      event.preventDefault(); closePanel();
      buttons[(index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length].focus();
    });
    on(root, 'focusout', event => { if (desktop.matches && !root.contains(event.relatedTarget)) closePanel(); });
    on(document, 'pointerdown', event => { if (desktop.matches && !root.contains(event.target)) closePanel(); });
    on(desktop, 'change', () => {
      setDrawer(false, false); closePanel(); shell.inert = !desktop.matches;
    });
    on(document, 'shopify:block:select', event => {
      if (!root.contains(event.target)) return;
      const item = event.target.closest('[data-vmm-item]');
      if (item) { if (!desktop.matches) setDrawer(true); openPanel(item); }
    });
    on(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      setDrawer(false, false); clearTimers(); controller.abort();
    });
    closePanel(); shell.inert = !desktop.matches;
  }
  window.voltMenuBoot = () => document.querySelectorAll('[data-vmm]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.voltMenuBoot);
  else window.voltMenuBoot();
  document.addEventListener('shopify:section:load', window.voltMenuBoot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["volt-menu-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('volt-menu-discovery')) return;
    const requests = new Map();
    const queue = [];
    let running = 0;
    const schedule = task => {
      queue.push(task);
      const drain = () => {
        while (running < 2 && queue.length) {
          running++;
          Promise.resolve(queue.shift()()).finally(() => { running--; drain(); });
        }
      };
      if ('requestIdleCallback' in window) requestIdleCallback(drain, { timeout: 1200 });
      else setTimeout(drain, 300);
    };
    const decode = value => new DOMParser().parseFromString(String(value), 'text/html').documentElement.textContent;
    const normalize = (value) => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const node = (tag, className, text) => {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    };
    async function getData(path, market) {
      const url = new URL(path, location.origin);
      url.search = '';
      url.searchParams.set('section_id', 'volt-menu-data');
      url.searchParams.set('sort_by', 'best-selling');
      const key = url.href + '|' + market;
      const storageKey = 'volt-menu-v2:' + key;
      if (!requests.has(key)) {
        try {
          const cached = JSON.parse(sessionStorage.getItem(storageKey));
          if (cached && Date.now() - cached.time < 300000) {
            requests.set(key, Promise.resolve(cached.data));
            return cached.data;
          }
        } catch (_) {}
        requests.set(key, fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(10000) }).then(async response => {
          if (!response.ok) throw new Error('Collection data unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = doc.querySelector('[data-volt-menu-data]');
          if (!payload) throw new Error('Collection data missing');
          const data = JSON.parse(payload.textContent);
          data.filters.forEach(filter => filter.values.forEach(value => { value.value = decode(value.value); }));
          try { sessionStorage.setItem(storageKey, JSON.stringify({ time: Date.now(), data })); } catch (_) {}
          return data;
        }).catch(error => { requests.delete(key); throw error; }));
      }
      return requests.get(key);
    }
    customElements.define('volt-menu-discovery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const panel = this.closest('[data-vmm-panel], [data-vnm-panel]');
        this.closest('[data-vmm], [data-vnm]').addEventListener(this.closest('[data-vnm]') ? 'vnm:open' : 'vmm:open', event => {
          if (event.detail.panel === panel) this.load();
        }, { signal: this.controller.signal });
        if (this.closest('.vmm-item.is-open')) this.load();
        this.closest('[data-vmm-item], [data-vnm-item]').addEventListener('pointerenter', () => this.load(), { signal: this.controller.signal });
        this.closest('[data-vmm-item], [data-vnm-item]').addEventListener('focusin', () => this.load(), { signal: this.controller.signal });
        if (!navigator.connection?.saveData) schedule(() => this.isConnected ? this.load() : undefined);
      }
      disconnectedCallback() { this.controller?.abort(); }
      async load() {
        if (this.loaded || this.loading || (this.classList.contains('vmm-discovery--desktop') && innerWidth < 1024)) return;
        this.loading = true;
        try {
          const data = await getData(this.dataset.source, this.dataset.market);
          const labels = JSON.parse(this.querySelector('[data-discovery-labels]').textContent);
          Object.keys(labels).forEach(key => {
            labels[key] = decode(labels[key]);
          });
          const content = this.dataset.mode === 'mega_filters' ? this.filters(data, labels) : this.brands(data, labels);
          this.querySelector('[data-discovery-content]').replaceChildren(content);
          this.querySelector('[data-discovery-fallback]').hidden = true;
          this.loaded = true;
          if (this.closest('[data-vnm]') && this.dataset.mode === 'mega_filters' && !content.children.length) this.hidden = true;
        } catch (_) {
          this.querySelector('[data-discovery-fallback]').hidden = false;
        } finally { this.loading = false; }
      }
      link(data, param, values) {
        const url = new URL(data.url, location.origin);
        url.search = '';
        values.forEach(value => url.searchParams.append(param, value));
        return url.pathname + url.search;
      }
      chip(data, filter, values, label, count) {
        const a = node('a', 'vmm-discovery__chip');
        a.href = this.link(data, filter.param, values);
        a.append(node('span', '', label));
        if (count !== undefined) a.append(node('span', 'vmm-discovery__count', count));
        return a;
      }
      filters(data, labels) {
        const result = node('div', 'vmm-discovery__filters');
        const sizing = node('div', 'vmm-discovery__group');
        const hp = data.filters.find(f => f.param === 'filter.p.m.custom.hp');
        if (this.dataset.hp === 'true' && hp?.values.some(v => v.count > 0)) {
          sizing.append(node('h3', 'vmm-discovery__heading', labels.hp));
          const chips = node('div', 'vmm-discovery__chips');
          for (const [min, max, title] of [[0, 4, '≤ 4 HP'], [5, 8, '5–8 HP'], [9, 12, '9–12 HP'], [13, 20, '13–20 HP'], [21, Infinity, '21+ HP']]) {
            const values = hp.values.filter(v => v.count > 0 && Number(v.label) >= min && Number(v.label) <= max);
            if (values.length) chips.append(this.chip(data, hp, values.map(v => v.value), title));
          }
          sizing.append(chips);
        }
        const diy = data.filters.find(f => f.param === 'filter.p.m.custom.diy');
        const yes = diy?.values.find(v => ['1', 'true'].includes(String(v.value)) && v.count > 0);
        if (this.dataset.diy === 'true' && yes) {
          const a = this.chip(data, diy, [yes.value], labels.diy, yes.count);
          a.classList.add('vmm-discovery__diy-link');
          const panel = this.closest('[data-vmm-panel], [data-vnm-panel]');
          let quick = panel.querySelector('.vmm-quick');
          if (!quick) {
            quick = node('div', 'vmm-quick');
            panel.querySelector('.vmm-rail__in').prepend(quick);
          }
          if (this.classList.contains('vmm-discovery--desktop')) a.classList.add('vmm-discovery--desktop');
          if (quick && !quick.querySelector('.vmm-discovery__diy-link')) {
            quick.append(a);
            quick.classList.add('vmm-quick--discovery');
          }
        }
        if (sizing.childElementCount) result.append(sizing);
        const functions = data.filters.find(f => f.param === 'filter.p.m.custom.module_functions');
        if (this.dataset.showFunctions === 'true' && functions?.values.some(v => v.count > 0)) {
          const group = node('div', 'vmm-discovery__group');
          group.append(node('h3', 'vmm-discovery__heading', labels.functions));
          const chips = node('div', 'vmm-discovery__chips');
          functions.values.filter(v => v.count > 0).sort((a, b) => b.count - a.count).slice(0, Number(this.dataset.functions)).forEach(v => chips.append(this.chip(data, functions, [v.value], v.label, v.count)));
          group.append(chips); result.append(group);
        }
        if (!result.childElementCount) result.hidden = true;
        return result;
      }
      brands(data, labels) {
        const result = node('div');
        const vendorFilter = data.filters.find(f => f.param === 'filter.p.vendor');
        const choices = vendorFilter?.values.filter(v => v.count > 0) || [];
        const vendors = [...new Set(data.vendors)].filter(v => choices.some(c => c.value === v)).slice(0, Number(this.dataset.limit));
        if (!vendors.length) return result;
        const heading = node('div', 'vmm-discovery__brand-head');
        heading.append(node('h3', 'vmm-discovery__heading', labels.brands), node('span', 'vmm-discovery__note', labels.brand_note));
        const logos = node('div', 'vmm-discovery__logos');
        vendors.forEach(vendor => {
          const key = normalize(vendor);
          const brand = data.brands.find(b => [b.name, b.handle, b.collection].some(n => normalize(n) === key));
          const a = node('a', 'vmm-discovery__brand');
          a.href = this.link(data, vendorFilter.param, [vendor]);
          if (brand?.logo) {
            const img = node('img');
            img.src = brand.logo; img.alt = ''; img.width = 84; img.height = 38; img.loading = 'lazy';
            img.addEventListener('error', () => { img.remove(); a.classList.add('vmm-discovery__brand--text'); }, { once: true });
            a.append(img);
          } else a.classList.add('vmm-discovery__brand--text');
          a.append(node('span', '', vendor)); logos.append(a);
        });
        result.append(heading, logos);
        return result;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
